import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-assistancevideonumber-card',
  templateUrl: './helpbutton-reports-assistancevideonumber-card.component.html',
  styleUrls: ['./helpbutton-reports-assistancevideonumber-card.component.scss']
})
export class HelpbuttonReportsAssistancevideonumberCardComponent implements OnInit {

  @Input() value;
  constructor() { }

  ngOnInit() {
  }

}
